<template>
  <div id="stepper-actions" class="col-12 flex justify-end items-center my3">
    <Button
      class="xs-hide sm-hide col-5 pointer"
      :action="() => click()"
      :color="color"
      :text="text"
      :text-size="textSize"
      :disabled="disabled"
    />
    <Button
      class="md-hide lg-hide col-12 pointer"
      :action="() => click()"
      :color="color"
      :text="text"
      :text-size="textSize"
      :disabled="disabled"
    />
  </div>
</template>

<script setup>

import Button from '../elements/Button';

const emit = defineEmits(['handleClickAction']);

defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: 'Étape suivante'
  },
  color: {
    type: String,
    default: 'violet-bg'
  },
  textSize: {
    type: String,
    default: ''
  }
});

const click = () => {
  emit('handleClickAction');
};

</script>
